import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function LookerIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <Box
        as="path"
        fill="#34A853"
        d="M9.957 0c-.965 0-1.75.785-1.746 1.75 0 .348.105.688.297.977l.746-.747a.74.74 0 0 1 .703-.969.74.74 0 0 1 .738.739.74.74 0 0 1-.968.703L8.98 3.2A1.746 1.746 0 1 0 10.941.31 1.709 1.709 0 0 0 9.957 0Z"
      />
      <Box
        as="path"
        fill="#FBBC04"
        d="M9.262 5.094a2.75 2.75 0 0 0-.543-1.637l-.969.969a1.383 1.383 0 0 1-.266 1.676l.528 1.289a2.738 2.738 0 0 0 1.25-2.297Z"
      />
      <Box
        as="path"
        fill="#EA4335"
        d="M6.555 6.484H6.53c-.77 0-1.39-.62-1.39-1.39a1.389 1.389 0 0 1 2.156-1.16l.96-.961a2.734 2.734 0 0 0-3.843.402 2.734 2.734 0 0 0 2.672 4.398l-.531-1.289Z"
      />
      <Box
        as="path"
        fill="#4285F4"
        d="M9.996 7.598a6.16 6.16 0 0 0-1.789.261l.77 1.875a4.186 4.186 0 0 1 5.207 4.059A4.186 4.186 0 0 1 10 17.977a4.181 4.181 0 0 1-1.96-7.879l-.76-1.871a6.2 6.2 0 1 0 5.446 11.14 6.205 6.205 0 0 0 2.843-8.297A6.206 6.206 0 0 0 10 7.598h-.004Z"
      />
    </Icon>
  );
}
